module.exports = __webpack_public_path__ + "static/media/insect(2).5af311df.PNG";